import { useCallback } from "react";
import _ from "lodash";

export const useBreakPoints = (
    breakpoints: { class: string; value: number }[],
    navRef: React.MutableRefObject<HTMLDivElement>
): (() => {
    class: string;
    value: number;
}) => {
    return useCallback(() => {
        if (navRef.current) {
            const width = navRef.current.clientWidth;
            const largest = breakpoints.find(d => d.value == null);
            const lowerThanLargest = breakpoints.filter(d => d.value != null);

            const breaks = _.orderBy(lowerThanLargest, d => d.value, "asc");

            const foundBreakPoint =
                breaks.find(bp => {
                    return width <= bp.value;
                }) ??
                largest ??
                breaks[breaks.length - 1];

            const bpClassNameToOne = breakpoints.reduce((prev, current) => {
                prev[current?.class ?? ""] = 1;
                return prev;
            }, {});

            navRef.current.classList.forEach(cls => {
                if (bpClassNameToOne[cls] === 1) navRef.current.classList.remove(cls);
            });

            foundBreakPoint && navRef.current.classList.add(foundBreakPoint.class);

            return foundBreakPoint;
        }
    }, [breakpoints, navRef]);
};
